import { Palette } from '@/types/palette.type';

export const paletteI18nHelper: Map<Palette, string> = new Map<Palette, string>([
  ['softSummerPalette', 'softSummerPaletteShort'],
  ['darkAutumnPalette', 'darkAutumnPaletteShort'],
  ['coldSummerPalette', 'coldSummerPaletteShort'],
  ['lightSpringPalette', 'lightSpringPaletteShort'],
  ['softAutumnPalette', 'softAutumnPaletteShort'],
  ['brightSpringPalette', 'brightSpringPaletteShort'],
  ['warmSpringPalette', 'warmSpringPaletteShort'],
  ['darkWinterPalette', 'darkWinterPaletteShort'],
  ['lightSummerPalette', 'lightSummerPaletteShort'],
  ['warmAutumnPalette', 'warmAutumnPaletteShort'],
  ['coldWinterPalette', 'coldWinterPaletteShort'],
  ['brightWinterPalette', 'brightWinterPaletteShort'],
]);
